import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowUIService implements OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();

  private showHorNavBar$ = new BehaviorSubject<boolean>(null);
  private showSideNavBar$ = new BehaviorSubject<boolean>(null);

  ngOnDestroy(): void {
    this.setShowHorNavBar(false);
    this.setShowSideNavBar(false);
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  // Says, if app.component.html should hide hor navbar.
  setShowHorNavBar(value: boolean): void {
    this.showHorNavBar$.next(value);
  }

  // Says, if app.component.html should hide side navbar.
  setShowSideNavBar(value: boolean): void {
    this.showSideNavBar$.next(value);
  }


  get showHorNavBar(): BehaviorSubject<boolean> {
    return this.showHorNavBar$;
  }

  get showSideNavBar(): BehaviorSubject<boolean> {
    return this.showSideNavBar$;
  }

}
